import React from 'react';
import { TrackingContext, TrackingPlacement } from '@mentimeter/http-clients';
import { RequestUpgradePopover } from '../../../lib/request-upgrade';
import { EngagementLimitUpgradeButton } from './EngagementLimitUpgradeButton';

export function EngagementLimitUpgradeToPresentPopover({
  isFreeUserInPaid,
}: {
  isFreeUserInPaid: boolean;
}) {
  if (isFreeUserInPaid) {
    return (
      <RequestUpgradePopover
        trackingContext={TrackingContext.Editview}
        trackingPlacement={
          TrackingPlacement.EngagementLimitsPresentButtonPaywall
        }
      >
        <EngagementLimitUpgradeButton />
      </RequestUpgradePopover>
    );
  }

  return <EngagementLimitUpgradeButton />;
}
